module.exports = new __parcel__URL__("logoInLadakh2.1b8e6fd9.png").toString();